export default __webpack_public_path__ + "static/step9-95ced59911005c459f59f7d89a237a09.svg";